module.exports = __webpack_public_path__ + "img/certificate1.ff4a66d5.png";